import axios from "axios";
import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth";
import { SHELFS } from "../const";
import {Content, ShelfItem, LiveShelf } from "../globalType";
import { getHost, translate, translate2, translateDefault } from "../utils";

type Props = {
  goToPage: (page: string, content: Content | null) => void;
  page: string;
};

export function SubMenu(props:Props) {
  const {goToPage, page} = props
  const authContext = useContext(AuthContext)
  const [entItems, setEntItems] = useState<ShelfItem[]>([]);

  useEffect(() => {
    fetchEntertainmentShelfs()
  }, [])

  const fetchEntertainmentShelfs = async () => {
    const result = await fetchShelf(SHELFS.entertainment)
    setEntItems(result.data)
  }

  const entCls = classNames({'active': page === 'entertainment'})
  const homeCls = classNames('bold', {'active': page === 'home'})

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className={homeCls}>Home</div>
                <div className={entCls} id="subMenu1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span onClick={() => {goToPage('/ondemand/home/categories/entertainment', null)}}>{translate('บันเทิง', 'Entertainment', authContext?.lang)}</span>
                    {entItems.length > 0 && (
                      <>
                        <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                        <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                      </>
                    )}
                    
                </div>
                <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu1">
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/sport`, null)}}>
                    {translate('บันเทิง', 'Entertainment', authContext?.lang)}
                  </a></li>
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/sport`, null)}}>
                    {translate('กีฬา', 'Sport', authContext?.lang)}
                  </a></li>
                </ul>
                

                <div className="web" id="subMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                        All categories 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                </div>
                <div className="mobile" id="subMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                        Category 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                </div>
                {entItems.length > 0 && (
                  <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu1">
                    {entItems.map((ent) => {
                      return <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/entertainment/${ent.id}`, null)}}>
                          {translate(ent.setting.title_th, ent.setting.title_en, authContext?.lang)}
                        </a></li>
                    })}
                </ul>
                )}
            </div>
        </div>
    </div>
    </>
  );
}

type SubcatMenuProps = {
  goToPage: (page: string, content: Content | null) => void;
  page: string;
  subcategorySlug: string | undefined;
};


export function SubCatSubMenu(props:SubcatMenuProps) {
  const {goToPage, page, subcategorySlug} = props
  const authContext = useContext(AuthContext)
  const [entItems, setEntItems] = useState<ShelfItem[]>([]);
  const [subcat, setSubcat] = useState<ShelfItem|null|undefined>(null)

  useEffect(() => {
    fetchEntertainmentShelfs()
  }, [])

  useEffect(() => {
    const shelf = entItems.find((item) => item.id === subcategorySlug)
    setSubcat(shelf)
  }, [entItems])

  const fetchEntertainmentShelfs = async () => {
    const result = await fetchShelf(SHELFS.entertainment)
    setEntItems(result.data)
  }

  const homeCls = classNames('bold', {'active': page === 'home'})

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className={homeCls}>Home</div>
                <div id="subMenu1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span onClick={() => {goToPage('/ondemand/home/categories/entertainment', null)}}>{translate('บันเทิง', 'Entertainment', authContext?.lang)}</span>
                    {entItems.length > 0 && (
                      <>
                        <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                        <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                      </>
                    )}
                    
                </div>
                <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu1">
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/sport`, null)}}>
                    {translate('บันเทิง', 'Entertainment', authContext?.lang)}
                  </a></li>
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/sport`, null)}}>
                    {translate('กีฬา', 'Sport', authContext?.lang)}
                  </a></li>
                </ul>
                

                <div className="web active" id="subMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                        {translateDefault(subcat?.setting.title_th, subcat?.setting.title_en, authContext?.lang, 'All Categories')} 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                </div>
                <div className="mobile active" id="subMenu2" data-bs-toggle="dropdown" aria-expanded="false">
                        {translateDefault(subcat?.setting.title_th, subcat?.setting.title_en, authContext?.lang, 'Categories')} 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                </div>
                {entItems.length > 0 && (
                  <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu1">
                    {entItems.map((ent) => {
                      return <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/entertainment/${ent.id}`, null)}}>
                          {translate(ent.setting.title_th, ent.setting.title_en, authContext?.lang)}
                        </a></li>
                    })}
                </ul>
                )}
            </div>
        </div>
    </div>
    </>
  );
}

type SportProps = {
  goToPage: (page: string, content: Content | null) => void;
  page: string;
  sportShelfs: LiveShelf[]};

export function SportSubMenu(props:SportProps) {
  const {goToPage, page} = props
  const authContext = useContext(AuthContext)

  const homeCls = classNames('bold', {'active': page === 'home'})

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className={homeCls}>Home</div>
                
                <div className='active' id="subMenu1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span onClick={() => {goToPage('/ondemand/home/categories/sport', null)}}>{translate('กีฬา', 'Sport', authContext?.lang)}</span>
                      <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                      <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                      
                </div>
                <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu1">
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/entertainment`, null)}}>
                    {translate('บันเทิง', 'Entertainment', authContext?.lang)}
                  </a></li>
                  <li><a className="dropdown-item" onClick={() => {goToPage(`/ondemand/home/categories/sport`, null)}}>
                    {translate('กีฬา', 'Sport', authContext?.lang)}
                  </a></li>
                </ul>
                <div data-bs-toggle="dropdown" className="web" id="subMenu2"  aria-expanded="false">
                        All categories 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                </div>
                <div data-bs-toggle="dropdown" className="mobile" id="subMenu2" aria-expanded="false">
                        Category 
                    <img src="/ondemand/static/img/down2.png" className="down2" alt="down" />
                    <img src="/ondemand/static/img/down1.png" className="down1" alt="down" />
                      
                </div>
                <ul className="subMenu-dp dropdown-menu dropdown-menu-dark " aria-labelledby="subMenu2">
                    <li><a className="dropdown-item" href="https://sport.trueid.net/">
                    {translate('ข่าวล่าสุด', 'News', authContext?.lang)}
                    </a></li>
                    <li><a className="dropdown-item" href="https://tv.trueid.net/live">
                    {translate('ฮอต อัพเดท', 'Hot Update', authContext?.lang)}
                    </a></li>
                    <li><a className="dropdown-item" href="https://sport.trueid.net/live">
                    {translate('กีฬา', 'Sports to watch', authContext?.lang)}
                    </a></li>
                </ul>
                
            </div>
        </div>
    </div>
    </>
  );
}


type LiveProps = {
  goToPage: (page: string, content: Content | null) => void;
};

export function LiveSubMenu(props:LiveProps) {
  const {goToPage} = props
  const authContext = useContext(AuthContext)

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className='bold'>Home</div>
                
                <div className='active' id="subMenu1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span onClick={() => {goToPage('/ondemand/schedule/', null)}}>{translate('ผังรายการ', 'TV Guide', authContext?.lang)}</span>
                </div>

                <div onClick={() => {goToPage('/ondemand/emagazine', null)}} className='bold'>e-magazine</div>
            </div>
        </div>
    </div>
    </>
  );
}

type EmagProps = {
  goToPage: (page: string, content: Content | null) => void;
};

export function EmagSubMenu(props:EmagProps) {
  const {goToPage} = props
  const authContext = useContext(AuthContext)

  return (
    <>
      <div className="subMenu-BG">
        <div className="container H-container">
            <div className="subMenu">
                <div className="mobile">
                    <img src="/ondemand/static/img/search.png" alt="" />
                </div>
                <div onClick={() => {goToPage('/ondemand/', null)}} className='bold'>Home</div>
                
                <div className='bold' id="subMenu1" data-bs-toggle="dropdown" aria-expanded="false">
                    <span onClick={() => {goToPage('/ondemand/schedule/', null)}}>{translate('ผังรายการ', 'TV Guide', authContext?.lang)}</span>
                </div>

                <div onClick={() => {goToPage('/ondemand/emagazine', null)}} className='bold active'>e-magazine</div>
            </div>
        </div>
    </div>
    </>
  );
}


async function fetchShelf(shelf: string) {
  const host = getHost()
  return axios.get(`${host}/api/series-shelfs/${shelf}`);
}

